import { faAlignJustify, faTrash } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useEffect, useState } from "react";

import { ColumnDescription } from "react-bootstrap-table-next";
import { useForm } from "react-hook-form";
import Swal from "sweetalert2";
import {
    AlterarSubCategoriaController,
    DeletarSubCategoriaController,
    ListarSubCategoriaController,
} from "../../../../../../../Controllers/Geral/GestaoDeCadastros/SubCategoria/SubCategoriaControllers";

import { IModuloComCategorias } from "../../../../../../../Interfaces/Geral/GestaoDeCadastro/CategoriaAtendimento/CategoriaAtendimentoInterface";
import { ISubCategoria } from "../../../../../../../Interfaces/Geral/GestaoDeCadastro/SubCategoria/SubCategoriaInterfaces";
import { IEmpreendimento } from "../../../../../../../Interfaces/Geral/Produtos/ProdutosInterface";
import SelectCategoriaAtendimento from "../../../../../../CardsPages/Forms/SelectCategoriaAtendimento";
import Table from "../../../../../../Table";

interface IListagemProps {
    lstEmpreendimento: Array<IEmpreendimento>;
    lstModulos: Array<IModuloComCategorias>;
}
interface IListarFormData {
    IDCategoria: number;
    IDProduto: number;
}

export default function Listagem(props: IListagemProps) {
    const { register, handleSubmit, control } = useForm<IListarFormData>();
    const [idModulo, setIdModulo] = useState<number>();
    const [lstSubCategorias, setLstSubCategorias] =
        useState<Array<ISubCategoria>>();

    const [listData, setListdata] = useState<IListarFormData>();

    function updateList(listData?: IListarFormData) {
        if (listData) {
            ListarSubCategoriaController(
                listData.IDCategoria,
                listData.IDProduto
            ).then(setLstSubCategorias);
        }
    }

    useEffect(() => {
        updateList(listData);
    }, [listData]);

    function handleListarFormSubmit(formData: IListarFormData) {
        setListdata(formData);
    }

    function rowDeletar(cell: number, row: any) {
        return (
            <div className="d-flex justify-content-end ml-2">
                <button
                    className="btn  btn-sm btn-outline-danger font-weight-bold"
                    onClick={() => {
                        Swal.fire({
                            title: "Deseja apagar esta subcategoria?",
                            icon: "info",
                            buttonsStyling: false,
                            confirmButtonText:
                                "<i class='la la-check'></i> Sim!",
                            showCancelButton: true,
                            cancelButtonText:
                                "<i class='la la-thumbs-down'></i> Não",
                            customClass: {
                                confirmButton: "btn btn-outline-success",
                                cancelButton: "btn btn-default",
                            },
                        }).then((result) => {
                            if (result.isConfirmed) {
                                DeletarSubCategoriaController(cell).then(() => {
                                    updateList(listData);
                                });
                            }
                        });
                    }}
                >
                    <FontAwesomeIcon icon={faTrash} size="lg" />
                </button>
            </div>
        );
    }
    const columns: Array<ColumnDescription> = [
        {
            dataField: "DS_SUBCATEGORIA_ATENDIMENTO",
            text: "Tipos de Relação Cliente",
            editable: true,
        },
        {
            dataField: "ID_SUB_CATEGORIA_ATENDIMENTO",
            text: "",
            formatter: rowDeletar,
        },
    ];

    return (
        <div>
            <form
                onSubmit={handleSubmit(handleListarFormSubmit)}
                className="row"
            >
                <div className="form-group col-12 col-lg-6">
                    <label>Tipo Caso</label>
                    <select
                        className={`form-control placeholder-dark-75`}
                        onChange={async (e) => {
                            setIdModulo(Number(e.target.value));
                        }}
                    >
                        <option></option>
                        {props.lstModulos.map((modulo) => (
                            <option
                                value={modulo.ID_MODULO}
                                key={modulo.ID_MODULO}
                            >
                                {modulo.DS_MODULO}
                            </option>
                        ))}
                    </select>
                </div>
                <div className="form-group col-12 col-lg-6">
                    <label>Categoria</label>
                    <SelectCategoriaAtendimento
                        ID_MODULO={idModulo}
                        className={`form-control placeholder-dark-75`}
                        name="IDCategoria"
                        control={control}
                    />
                </div>
                <div className="form-group col-12 col-lg-6">
                    <label>Empreendimento</label>
                    <select
                        className={`form-control placeholder-dark-75`}
                        name="IDProduto"
                        ref={register({
                            valueAsNumber: true,
                        })}
                    >
                        <option></option>
                        {props.lstEmpreendimento.map((empreendimento) => (
                            <option
                                value={empreendimento.ID_EMPREENDIMENTO}
                                key={empreendimento.ID_EMPREENDIMENTO}
                            >
                                {empreendimento.DS_EMPREENDIMENTO}
                            </option>
                        ))}
                    </select>
                </div>

                <div className="col-12">
                    <button
                        type="submit"
                        className="btn btn-outline-success font-weight-bold col-12 justify-content-center"
                    >
                        <FontAwesomeIcon
                            icon={faAlignJustify}
                            size="lg"
                            className="mr-1"
                        />{" "}
                        Listar
                    </button>
                </div>
            </form>

            {lstSubCategorias && (
                <div className="d-flex flex-columns row">
                    <div className="col-12 mt-5">
                        <Table
                            keyField="ID_SUB_CATEGORIA_ATENDIMENTO"
                            columns={columns}
                            data={lstSubCategorias}
                            bordered={false}
                            edit={{
                                onEdit: async (cell, row) => {
                                    AlterarSubCategoriaController({
                                        ...row,
                                        DS_SUBCATEGORIA_ATENDIMENTO: cell,
                                    }).then(() => {
                                        updateList(listData);
                                    });
                                },
                            }}
                        />
                    </div>
                </div>
            )}
            {lstSubCategorias && <div>Lista</div>}
        </div>
    );
}
